module.exports = __webpack_public_path__ + "static/media/DecIdFront.catalyst.a1d4ce2e.tsx";